<template lang="pug">
	div
		appBanner(v-if="withBanner && !desk")
		block-header
		.page
			.wrapper
				block-categories
				list-section(
					:title="'Акції'"
					:list="promos"
					:type="'new'"
					:link="'/promos/'"
				)
		block-footer
</template>

<script>

  let collectionSlug = 'promos';

	import ListSection from '@/components/listSection.vue';

	import AOS from 'aos';

	import BlockCategories from '@/components/newsCategories.vue';

	import {mapState} from 'vuex';

	export default {
		name: collectionSlug,
		metaInfo: function() {
			return {
				title: 'Акції'
			}
		},
		data: function(){
			return {
			}
		},
		created() {
			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);
		},
		computed: {
			...mapState([
				collectionSlug,
        'withBanner',
        'desk'
			])
		},
		mounted() {
			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		components: {
			'list-section': ListSection,
			'block-categories': BlockCategories,
		}
	}

</script>

<style lang="scss" scoped>


  >>> .card {
		.card__category {
			display: none;
		}

		&__info {
			padding-top: 17px !important;
			padding-bottom: 36px !important;
		}

		&__date {
			font-size: 11px;
			bottom: 9px;
		}

		&__title {
			font-size: 14px;
			line-height: 19px;
			height: 55px !important;
		}
	}

	@media screen and (max-width: 1200px) {
    >>> .section__list {
			margin-bottom: 80px;
		}
	}
</style>
